var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('main-navigation'),_c('v-main',[_c('router-view'),_c('v-footer',{staticClass:"main-footer"},[_c('common-footer')],1)],1),_c('AppError',{attrs:{"isAuth":true}}),_c('AuthCheck'),_c('ServerCommandsController')],1)}
var staticRenderFns = []

export { render, staticRenderFns }